import { motion } from 'framer-motion'
import SignupForm from './SignupForm'
import ShareNudge from './ShareNudge'

const EASE = [0.16, 1, 0.3, 1]

export default function FinalCta() {
  return (
    <section className="relative overflow-hidden bg-[#C9D9EE]/55 px-6 py-28 md:px-10 md:py-44" data-testid="final-cta-section">
      <svg
        viewBox="0 0 1440 220"
        preserveAspectRatio="none"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-[13vh] w-full"
        aria-hidden="true"
        data-testid="final-cta-waves"
      >
        <path d="M0 220 L 0 120 C 240 60, 480 170, 720 130 C 960 90, 1200 150, 1440 100 L 1440 220 Z" fill="#FAF7F2" />
      </svg>
      <div
        aria-hidden="true"
        className="blob pointer-events-none absolute left-1/2 top-1/2 h-[70vh] w-[70vh] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-70"
        style={{ background: 'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.6), rgba(255,255,255,0) 68%)' }}
      />
      <div className="relative mx-auto flex max-w-2xl flex-col items-center text-center">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.9, ease: EASE }}
          className="eyebrow"
          data-testid="final-cta-eyebrow"
        >
          ( 02 ) — Stay close
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 1.05, ease: EASE, delay: 0.1 }}
          className="display-l mt-7 max-w-[14ch]"
          data-testid="final-cta-headline"
        >
          Something better is coming.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.22 }}
          className="mt-6 text-lg leading-relaxed text-haze"
          data-testid="final-cta-copy"
        >
          Be among the first to know when No More Bluff goes live.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.34 }}
          className="mt-10 w-full"
          data-testid="final-cta-signup-form"
        >
          <SignupForm testIdPrefix="cta" />
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: EASE, delay: 0.5 }}
          className="mt-2 flex items-center gap-2 text-[0.8rem] text-haze"
          data-testid="final-cta-microcopy"
        >
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#FCD116]" />
          No spam. Just the occasional update when something worth knowing is happening.
        </motion.p>

        <ShareNudge testIdPrefix="cta" />
      </div>
    </section>
  )
}
